import { useRoutes } from 'react-router';
import { MantineProvider } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { NotificationsProvider } from '@mantine/notifications';
import { useEffect, useState, useCallback, useMemo } from 'react';
import jwtDecode from 'jwt-decode';

import { Provider } from 'react-redux';
import routes from './router/routes';
import { store } from './store';
import './i18n';
import './App.css';

import AppContext from './components/Context/index';

const App = () => {
  const navigate = useNavigate();
  const routeElement = useRoutes(routes);

  const [appState, setAppState] = useState({ isAuthenticated: false });
  const [, setLoading] = useState(true);

  let token;
  let userData;
  const getAuthentiacation = useCallback(async () => {
    if (!appState?.isAuthenticated) {
      token = localStorage.getItem('token');
      userData = localStorage.getItem('userData');
      if (token && token !== '') {
        const decodedData = await jwtDecode(token);
        if (decodedData?.exp < Date.now() / 1000) {
          localStorage.setItem('token', '');
          localStorage.setItem('userData', '');
          return;
        }
        // updateFetcher(token, false);
        setAppState({
          ...appState,
          ...decodedData,
          ...(userData ? JSON.parse(userData) : {}),
          isAuthenticated: true,
          token,
        });

        return;
      }
      // updateFetcher(nanoid(), true);
    }
    setLoading(false);
  }, [appState]);

  useEffect(() => {
    getAuthentiacation();
    if (appState?.isAuthenticated) {
      navigate('/home');
    } else {
      navigate('/');
    }
  }, [appState?.isAuthenticated]);

  const handleUserLogin = (data) => {
    const decodedData = jwtDecode(data?.token);
    setAppState({
      ...appState,
      ...decodedData,
      ...data,
      isAuthenticated: true,
      token,
    });
    localStorage.setItem('token', data?.token);
    localStorage.setItem('userData', JSON.stringify(data));
  };

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decodedToken.exp < currentTime) {
        localStorage.setItem('token', '');
        localStorage.setItem('userData', '');
        navigate('/');
      }
    }
  }, [token]);
  const memoizedValue = useMemo(
    () => ({
      appState,
      setAppState,
      handleUserLogin,
    }),
    [appState, setAppState, handleUserLogin],
  );

  return (
    <AppContext.Provider value={memoizedValue}>
      <MantineProvider
        className="example"
        withGlobalStyles
        withNormalizeCSS
        theme={{
          breakpoints: {
            xs: 500,
            sm: 800,
            md: 1000,
            lg: 1200,
            xl: 1400,
          },

          colors: {
            brand: [
              '#f2f2f2',
              '#e6e6e6',
              '#bfbfbf',
              '#999999',
              '#4d4d4d',
              '#000000',
              '#000000',
              '#000000',
              '#000000',
              '#000000',
            ],
          },
          primaryColor: 'brand',
        }}
      >
        <NotificationsProvider position="bottom-center">
          <Provider store={store}>{routeElement}</Provider>
        </NotificationsProvider>
      </MantineProvider>
    </AppContext.Provider>
  );
};

export default App;
